import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const Estimate = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.estimate.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.estimate.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 68%;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/estimate-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/estimate-bg-mob.png') type('image/png')
      )
      16px 100% / calc(100% - 16px) auto no-repeat,
    #ffffff`};

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 46.41%;
    background: ${(p) => `image-set(
          url('/images/mainpage/estimate-bg-tab-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/estimate-bg-tab-${p.locale}.png') type('image/png')
        )
        30px 100% / calc(100% - 30px) auto no-repeat,
      #ffffff`};
  }

  @media ${Points.laptop_wide} {
    padding: 40px 40px 49.6%;
    background: ${(p) => `image-set(
          url('/images/mainpage/estimate-bg-lap-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/estimate-bg-lap-${p.locale}.jpg') type('image/jpeg')
        )
        40px 100% / calc(100% - 40px) auto no-repeat,
      #ffffff`};
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }
`;
